import groq from 'groq'
import { mediaAsset } from '../../../projections/mediaAsset'

export const capabilities = groq`
  _type,
  title,
  builtFor{
    title,
    description,
    image[]{...${mediaAsset()}}
  },
  capabilitiesTitle,
  capabilities[]{
    title,
    description,
    "icon": icon->slug,
  },
`
